module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/NB Dual Camera.138a6ed7.png";